export default {
  "app_name": import.meta.env.VITE_APP_SITE_NAME,
  "shopping_agent": "Agent zakupowy",
  "forwarding": "Spedycja",
  "services": "Usługi",
  "about": "O nas",
  "expert_buy": "Zakup ekspercki",
  "shipping_calculator": "Kalkulator wysyłki",
  "customer_review": "Opinie klientów",
  "dropshipping": "Dropshipping",
  "business_service": "Usługi dla firm",
  "trusted_seller": "Zaufani sprzedawcy",
  "blog": "Blog",
  "user_guides": "Poradniki użytkownika",
  "terms_of_service": "Warunki świadczenia usług",
  "terms_of_shipping": "Warunki wysyłki",
  "privacy_policy": "Polityka prywatności",
  "faq": "Często zadawane pytania",
  "home": "Strona główna",
  "notice": "Powiadomienia",
  "cart": "Koszyk",
  "me": "Moje konto",
  "service_menu": "Menu usług",
  "account": "Konto",
  "user_center": "Centrum użytkownika",
  "my_order": "Moje zamówienia",
  "my_store": "Mój sklep",
  "log_out": "Wyloguj się",
  "sign_in": "Zaloguj się",
  "sign_up": "Zarejestruj się",
  "compensation_taxation": "Odszkodowania i podatki",
  "tok_forum": "Forum",
  "get_community_help": "Dołącz do naszego forum",
  "community_des": "Dołącz do naszego forum, aby uzyskać pomoc i pomagać innym",
  "page_home": {
    "title": "Twój ostateczny cel",
    "description": "Chiński agent zakupowy",
    "search_product_text": "URL produktu",
    "timeline": [
      {
        "title": "Złóż zamówienie",
        "subtitle": "Wybór i zakup"
      },
      {
        "title": "Wyślij paczki",
        "subtitle": "Kontrola jakości i wysyłka międzynarodowa"
      },
      {
        "title": "Odbierz",
        "subtitle": "Odbierz i udostępnij"
      }
    ],
    "cards": [
      ["Zarejestruj się", "i otrzymaj kupon o wartości 350 €!"],
      ["Przewodnik", "dla początkujących"],
      ["Dołącz do nas", "na Reddit i Discord"]
    ],
    "shop_chinese": {
      "title": "Kupuj na chińskich platformach e-commerce",
      "cards": [
        {
          "title": "Składaj zamówienia",
          "description": "Ciesz się bezproblemowymi zakupami dowolnego produktu z Chin, dostępnego online lub offline. Aby złożyć zamówienie, po prostu wklej link do produktu. Korzystaj z naszej pełnej obsługi, od wyszukiwania po zakup, z całkowitą łatwością."
        },
        {
          "title": "Wysyłka do magazynu NiuniuBox",
          "description": "Kupuj od różnych sprzedawców za pośrednictwem naszej usługi, a my sprawnie połączymy Twoje zakupy. Wszystkie przedmioty zostaną wysłane do magazynu NiuniuBox w Chinach, co uprości dla Ciebie proces."
        },
        {
          "title": "Kontrola jakości",
          "description": "Gdy Twoje produkty dotrą do magazynu NiuniuBox, przechodzą rygorystyczną kontrolę jakości. Nasz zespół dokładnie sprawdza każdy przedmiot pod kątem wad i zgodności rozmiaru, koloru itp. Z NiuniuBox możesz być spokojny o naszą dedykowaną obsługę posprzedażową."
        },
        {
          "title": "Wysyłka międzynarodowa",
          "description": "Wybierz produkty ze swojego stanu magazynowego i łatwo połącz je w jedną paczkę. Dzięki niezawodnym międzynarodowym usługom wysyłkowym NiuniuBox Twoje zakupy są dostarczane prosto do Twoich drzwi. Ciesz się wygodą światowej klasy usług wysyłkowych."
        }
      ]
    },
    "bottom": [
      {
        "title": "Bogactwo produktów",
        "description": "Znajdujemy dla Ciebie różnorodne i niedrogie produkty z Chin"
      },
      {
        "title": "Obniżone koszty",
        "description": "Jeden koszt wysyłki dla produktów od różnych sprzedawców, wszystko połączone w jedną paczkę"
      },
      {
        "title": "Jakość usług",
        "description": "Cenimy Twoją lojalność, a naszym celem jest oferowanie wyjątkowej obsługi i wsparcia"
      },
      {
        "title": "Szybka odpowiedź",
        "description": "Gwarantowana odpowiedź na wszystkie Twoje pytania dotyczące naszych usług"
      }
    ],
    "migration": {
      "title": "Ważna informacja",
      "dear_users": "Drodzy Użytkownicy,",
      "announce_before_link": "Z przyjemnością informujemy, że Niuniubox został oficjalnie przemianowany na Pikobuy ",
      "link_label": "www.pikobuy.com",
      "closing": "Nadal będziemy świadczyć dla Państwa usługi pod nową marką.",
      "got_it": "Rozumiem"
    }
  },
  "page_shopping": {
    "shopping_des": "Zakupy z Chin",
    "shopping_step": "1.Znajdź i wyszukaj produkt 2.Zapłać za przedmioty 3.My kupujemy dla Ciebie 4.Zapłać za wysyłkę 5.My wysyłamy dla Ciebie",
    "category": "Kategoria",
    "load_more_items": "Załaduj więcej przedmiotów",
    "note": "Zastrzeżenie: Wszystkie produkty dostępne w ramach naszej usługi agenta zakupowego wyświetlane na naszej stronie internetowej pochodzą z platform zakupowych stron trzecich i nie są sprzedawane bezpośrednio przez nas. W związku z tym nie ponosimy odpowiedzialności za jakiekolwiek problemy wynikające z naruszenia praw własności intelektualnej lub praw autorskich do towarów.",
    "bottom_text": "Jako profesjonalny agent Taobao pomagamy Ci kupować liczne produkty po bardzo niskich cenach z największych chińskich witryn zakupowych. Jesteśmy Twoim agentem Taobao do wyszukiwania, kupowania, sprawdzania i dostarczania przedmiotów z Taobao.com, 1688.com. Nasza wycena obejmuje zaopatrzenie w Chinach, zakupy i wysyłkę międzynarodową. Oferujemy największe zniżki na wysyłkę międzynarodową z Chin do wszystkich krajów, w tym USA, Kanady, Wielkiej Brytanii, Australii, Francji, Singapuru, Meksyku, Brazylii, Chile itp. Gdziekolwiek jesteś, dostarczamy paczki prosto pod Twoje drzwi. Zapewniamy informacje o śledzeniu online dla wszystkich przesyłek. Mamy profesjonalnych menedżerów obsługi klienta, którzy pomogą Ci pomyślnie dokonać zakupów i wysyłki.",
    "process_data": "Przetwarzaj dane",
    "process_des": "Możesz dowiedzieć się wszystkiego o swoim zamówieniu. Kiedykolwiek się martwisz, mamy dane, które powiedzą Ci wszystko."
  },
  "meta": {
    "index_title": "Agent Taobao | Agent Tmall | Agent 1688 | Taobao po polsku | Agent zakupowy | Spedytor z Chin",
    "index_des": "Jesteśmy chińską platformą agentów zakupowych. Pomagamy klientom kupować produkty na Taobao. Kupowanie ulubionych przedmiotów z Chin nigdy nie było tak wygodne i łatwe.",
    "shopping_agent_title": "Agent zakupowy",
    "shopping_agent_des": "Kupuj chińskie produkty z agentem zakupowym. Agent Taobao, agent 1688, agent Weidian, agent Yupoo.",
    "forwarding_title": "Agent spedycyjny - Wyślij swoją paczkę z Chin",
    "forwarding_des": "Profesjonalna globalna platforma spedycyjna, posiadająca magazyny przeładunkowe i świadcząca profesjonalne usługi logistyczne do USA, Wielkiej Brytanii, Kanady, Niemiec, Australii, Singapuru, Meksyku i innych krajów, wysyłka na cały świat",
    "expert_buy_title": "Zakup ekspercki",
    "expert_buy_des": "Kupuj produkty za pośrednictwem agenta Taobao, importuj z Chin. Najniższe ceny wysyłki. Brak opłat za obsługę.",
    "calculator_title": "Szacowanie międzynarodowych kosztów logistycznych",
    "calculator_des": "Pomagamy oszacować globalne koszty logistyczne. Przystępna usługa logistyczna. Najszybsza usługa logistyczna.",
    "trusted_seller_title": "Zaufani sprzedawcy",
    "trusted_seller_des": "Zaufani sprzedawcy: Kupuj od tych sprzedawców, a my wyślemy dla Ciebie. Sprzedawcy Taobao, sprzedawcy Weidian."
  },
  "my_parcel": {
    "internationalParcels": "Paczki międzynarodowe",
    "trackYourInternationalShipments": "Śledź swoje międzynarodowe przesyłki i ustaw preferencje wysyłki",
    "pleaseSelect": "Proszę wybrać",
    "yourRemark": "Twoja uwaga",
    "startDate": "Data początkowa",
    "endDate": "Data końcowa",
    "alertTrackParcels": "Śledź swoje paczki tutaj. Paczki o statusie 'Gotowe do skonfigurowania wysyłki' zostały spakowane i zmierzone i są gotowe do skonfigurowania wysyłki.",
    "noPackagesToShip": "Nie masz paczek do wysłania",
    "parcel": "Paczka",
    "parcelID": "ID paczki:",
    "shippingLabel": "Opłaty za wysyłkę:",
    "pending": "oczekujące",
    "finalFee": "Opłata końcowa:",
    "discount": "Rabat:",
    "coupon": "Kupon:",
    "created": "Utworzono:",
    "status": "Status",
    "shippingMethod": "Metoda wysyłki",
    "notConfiguredYet": "Jeszcze nie skonfigurowano",
    "products": "produkt(y)",
    "measured": "Zmierzono",
    "estimated": "Szacowano",
    "dimensions": "Wymiary:",
    "weightInformation": "Informacje o wadze",
    "billingWeight": "Waga do rozliczenia:",
    "na": "B/D",
    "actual": "Rzeczywista:",
    "volume": "Objętość:",
    "action": "Akcja",
    "configureShippingMethod": "Skonfiguruj metodę wysyłki",
    "payShipping": "Zapłać za wysyłkę",
    "track": "Śledź",
    "address": "Adres",
    "shipping": "Wysyłka:",
    "configure": "Skonfiguruj",
    "pay": "Zapłać",
    "viewMoreProducts": "Zobacz więcej produktów w tej paczce",
    "orderID": "ID zamówienia:",
    "quantity": "Ilość:",
    "times": "x",
    "addressLabel": "Adres",
    "yourRemarkTitle": "Twoja uwaga",
    "parcelRemarkTitle": "Uwaga do paczki",
    "noRemarks": "Brak uwag do tej paczki",
    "parcelImages": "Zdjęcia paczki",
    "failedToLoad": "Nie udało się załadować",
    "noImages": "Brak dostępnych zdjęć dla tej paczki",
    "productsInParcel": "Produkty w paczce",
    "type": "Typ:",
    "noProducts": "Brak dostępnych szczegółów produktów dla tej paczki",
    "configureShipping": "Skonfiguruj wysyłkę",
    "alertPackagePrepared": "Twoja paczka została przygotowana. Teraz wybierz metodę wysyłki i podaj adres dostawy.",
    "packageDetails": "Szczegóły paczki",
    "readyForShipping": "Gotowe do wysyłki",
    "actualWeight": "Waga rzeczywista:",
    "actualDimensions": "Wymiary rzeczywiste:",
    "packagingNotes": "Uwagi dotyczące pakowania:",
    "step1SubmitAddress": "Krok 1: Prześlij adres",
    "select": "Wybierz",
    "recipientName": "Imię i nazwisko odbiorcy",
    "email": "E-mail",
    "phoneNumber": "Numer telefonu",
    "country": "Kraj",
    "city": "Miasto",
    "stateProvince": "Województwo/Prowincja",
    "zipCode": "Kod pocztowy",
    "selectShippingMethod": "Wybierz metodę wysyłki",
    "selectCountryFirst": "Najpierw wybierz kraj",
    "selectedShippingMethod": "Wybrana metoda wysyłki",
    "estimatedDelivery": "Szacowany czas dostawy",
    "estimatedFee": "Szacowana opłata:",
    "changeShippingMethod": "Zmień metodę wysyłki",
    "remark": "Uwaga",
    "shippingRemarkPlaceholder": "CPF / CNPJ / NIP / uwaga do wysyłki",
    "saveAddress": "Zapisz adres",
    "saveAddressHint": "Zapisz ten adres w swojej książce adresowej do przyszłego użytku",
    "submitShippingConfiguration": "Prześlij konfigurację wysyłki",
    "parcelDetailsTitle": "Szczegóły paczki",
    "statusSection": "Status",
    "actions": "Akcje",
    "parcelDetails": "Szczegóły paczki",
    "trackingInfo": "Informacje o śledzeniu",
    "addressInfo": "Informacje adresowe",
    "costDetails": "Szczegóły kosztów",
    "costPending": "oczekujące",
    "shippingMethodNotConfigured": "Metoda wysyłki nie została skonfigurowana",
    "packageDimensions": "Wymiary paczki",
    "measuredDimensions": "Zmierzono wymiary",
    "estimatedDimensions": "Szacowane wymiary",
    "length": "Długość:",
    "width": "Szerokość:",
    "height": "Wysokość:",
    "totalVolume": "Całkowita objętość:",
    "volumetricWeight": "Waga objętościowa:",
    "weightCalculation": "Obliczanie wagi",
    "weightCalcVolumeUsed": "Użyta waga objętościowa (większa z nich)",
    "weightCalcActualUsed": "Użyta waga rzeczywista (większa z nich)",
    "billingWeightTooltip": "Jest to waga używana do rozliczeń (większa z wagi rzeczywistej i objętościowej)",
    "remarks": "Uwagi",
    "delivery_number": "ID paczki"
  },
  "footer": {
    "supportTitle": "Wsparcie",
    "support": ["O nas", "Kontakt", "Opłaty za usługi", "Koszty wysyłki"],
    "servicesTitle": "Usługi",
    "services": ["Zakupy na Taobao", "Agent Yupoo", "Agent Weidian", "Zaopatrzenie w produkty"],
    "tutorialTitle": "Poradnik",
    "tutorial": ["Przewodnik po zakupach", "Nasz blog", "Koszty wysyłki"],
    "resourcesTitle": "Zasoby",
    "resources": ["Polityka wysyłki", "Zwroty i refundacje", "Polityka prywatności", "Warunki świadczenia usług"],
    "followTitle": "Śledź nas",
    "follow": ["Youtube", "TikTok", "Facebook", "Quora", "Twitter"],
    "copyright": "© 2025 NiuNiuBox - Hong Kong Niuniubox Technology Co., Limited",
    "paymentMethods": ["PayPal", "American Express", "Discover", "JCB", "Mastercard", "VISA"]
  },
  "sidebar_titles": ["PROFIL UŻYTKOWNIKA", "ZAMÓWIENIA I WYSYŁKA", "FINANSE", "KONTO"],
  "sidebar": ["Konto", "Zamówienie", "Magazyn", "Próba", "Paczka", "Adresy", "Anuluj", "Historia", "Saldo", "Wiadomości", "Kupon", "Ustawienia", "Program partnerski"],
  "page_order_history": {
    "title": "Historia zamówień",
    "search": {
      "order_number_placeholder": "Numer zamówienia",
      "product_name_placeholder": "Nazwa produktu",
      "remark_placeholder": "Uwaga",
      "style_sku_placeholder": "Styl/SKU",
      "start_date_placeholder": "Data początkowa",
      "end_date_placeholder": "Data końcowa",
      "status_placeholder": "Proszę wybrać"
    },
    "buttons": {
      "search": "Szukaj",
      "pay_shopping_orders": "Zapłać za zamówienia",
      "pay_order": "Zapłać za zamówienie",
      "view_order": "Zobacz zamówienie",
      "item_photos": "Zdjęcia przedmiotu",
      "view_product": "Zobacz produkt"
    },
    "table": {
      "empty_text": "Nie masz jeszcze żadnych zamówień.",
      "header": {
        "image": "Zdjęcie",
        "details": "Szczegóły",
        "product": "Produkt",
        "action": "Akcja"
      },
      "body": {
        "order": "Zamówienie:",
        "total": "Suma:",
        "type": "Typ:",
        "status": "Status:",
        "time": "Data:",
        "style": "Styl:",
        "quantity": "Ilość:",
        "remark": "Uwaga:",
        "name": "Nazwa:"
      }
    },
    "qc_dialog": {
      "title": "Zdjęcia kontroli jakości",
      "notice": "Od sierpnia nie będziemy już oferować usługi zdjęć QC.",
      "empty_description": "Twój przedmiot jeszcze nie dotarł do naszego magazynu."
    }
  },
  "navbar": {
    "items": ["Szacowanie wysyłki", "Program partnerski", "Kontakt", "Przewodnik"],
    "cart": "Koszyk",
    "login": "Zaloguj się",
    "register": "Zarejestruj się",
    "logout": "Wyloguj się",
    "no": "Nie",
    "logout_confirm": "Czy na pewno chcesz się wylogować?",
    "search": "Szukaj",
    "searchPlaceholder": "URL produktu",
    "dropdown": ["Centrum użytkownika", "Wiadomość", "Zamówienie", "W magazynie", "Moje próby", "Moje paczki", "Anuluj zamówienie", "Wyloguj się"],
    "me": "Ja",
    "home": "Strona główna",
    "menu": "Menu",
    "notice": "Powiadomienia"
  },
  "page_my_order": {
    "product_pic": "Zdjęcie produktu",
    "product_qc": "Zdjęcie QC",
    "store_order_no": "Numer zamówienia sklepu",
    "type": "Typ",
    "details": "Zobacz",
    "remark": "Uwaga",
    "process": "W trakcie",
    "cn_track": "Śledzenie w CN",
    "pay_order": "Zapłać za zamówienie",
    "search": "Szukaj"
  },
  "page_calculator": {
    "des": "Oblicz światową cenę wysyłki",
    "item_category": "Kategoria produktu",
    "product_weight": "Waga",
    "product_length": "Długość",
    "product_width": "Szerokość",
    "product_height": "Wysokość",
    "check": "Sprawdź teraz",
    "cost_note": "Uwaga: waga paczki nie może być mniejsza niż 2,5 kg dla UPS/DHL/FedEx. W przeciwnym razie może być wysłana tylko linią małych paczek.",
    "about_service": "Nasz kalkulator wysyłki to dodatkowa funkcja, którą oferujemy na naszej stronie internetowej w ramach naszych usług agenta zakupowego i międzynarodowych usług kurierskich. Korzystając z naszego kalkulatora wysyłki, możesz oszacować przybliżone koszty wysyłki do zapłaty na podstawie wymiarów Twoich produktów lub paczek i kraju docelowego. Możesz również użyć naszego kalkulatora do sprawdzenia różnych firm przewozowych dostępnych dla Twojego kraju docelowego, a także ich szacowanych czasów wysyłki.",
    "service_title": "O kalkulatorze",
    "common_goods": "Towary zwykłe",
    "brand_goods": "Produkty markowe",
    "liquid_goods": "Produkty płynne",
    "battery_goods": "Produkty z bateriami",
    "shipping_method": "Metoda wysyłki",
    "delivery_time": "Czas dostawy",
    "warehouse": "Magazyn",
    "estimated_cost": "Szacowany koszt",
    "method": "Metoda"
  },
  "page_message": {
    "title": "Wiadomość",
    "des": "Powinieneś zwracać uwagę na tę część wiadomości, ponieważ wyślemy Ci wiadomość lub e-mail."
  },
  "page_cart": {
    "title": "Mój koszyk",
    "item": "Przedmiot",
    "product": "Produkt",
    "price": "Cena",
    "quantity": "Ilość",
    "freight": "Fracht",
    "total": "Suma",
    "info": "Informacje",
    "operate": "Operuj",
    "pay_now": "Zapłać teraz",
    "confirm_buy": "Potwierdzić zakup?",
    "yes": "Tak",
    "no": "Nie"
  },
  "page_settlement": {
    "title": "Potwierdź swoje zamówienie",
    "information": "Uwaga",
    "note_line1": "1. Zrób darmowe zdjęcia produktu",
    "note_line2": "2. Kwota płatności obejmuje koszt towarów, opłatę za przetwarzanie płatności i opłatę za usługę",
    "note_line3": "3. Poinformujemy Cię o postępach w realizacji zamówienia przez e-mail. Sprawdzaj go na bieżąco",
    "note_line4": "4. Gdy Twoje paczki dotrą do magazynu, będziesz musiał zapłacić za wysyłkę",
    "note_line5": "5. Musisz zapłacić dodatkową opłatę za każdą płatność (PayPal)"
  },
  "page_shopping_payment": {
    "title": "Pierwsza płatność za produkty",
    "des": "Uwaga: na tej stronie można zapłacić tylko za produkty. Koszty wysyłki płaci się na stronie #Paczki międzynarodowe#.",
    "total": "Suma",
    "order_no": "Zamówienie",
    "pay_now": "Przejdź do płatności",
    "shopping_notice": "Ważna uwaga:"
  },
  "page_person": {
    "account": "Konto",
    "user_center": "Centrum użytkownika",
    "wallet": "Portfel",
    "orders": "Zamówienia",
    "my_order": "Moje zamówienie",
    "my_warehouse": "W magazynie",
    "my_parcel": "Paczki międzynarodowe",
    "address_book": "Książka adresowa",
    "online_store": "Sklep internetowy",
    "my_store": "Mój sklep",
    "activity": "Aktywność",
    "invite": "Zaproś",
    "coupons": "Kupony"
  },
  "page_seller": {
    "title": "Zaufany sprzedawca",
    "buy_hanfu_title": "Kup chińskie Hanfu od tych sprzedawców, a my wyślemy Twoją paczkę",
    "buy_sneaker_title": "Kup trampki od tych sprzedawców, a my wyślemy Twoją paczkę",
    "buy_cosplay_title": "Kup produkty cosplayowe od tych sprzedawców, a my wyślemy Twoją paczkę",
    "step_line1": "1. Znajdź produkty od tych sprzedawców",
    "step_line2": "2. Złóż zamówienie zakupu",
    "step_line3": "3. My wyślemy je do Ciebie"
  },
  "page_profile": {
    "account": "Konto",
    "email": "E-mail",
    "balance": "Saldo"
  },
  "page_wallet": {
    "top_up": "Doładuj",
    "underpaid": "Niedopłata",
    "balance_details": "Szczegóły salda",
    "time": "Czas",
    "empty": "Brak zapisów",
    "amount": "Kwota",
    "status": "Status",
    "info": "Informacje",
    "pay": "Zapłać",
    "paid": "Zapłacono",
    "confirm": "Potwierdź",
    "discount_info": "Informacje o zniżce",
    "and_get": "i otrzymaj",
    "get_extra": "dodatkowo"
  },
  "in_warehouse": {
    "packages_in_warehouse": "Paczki w magazynie",
    "product_name": "Nazwa produktu",
    "please_select": "Proszę wybrać",
    "remark": "Uwaga",
    "style_sku": "Styl/SKU",
    "start_date": "Data początkowa",
    "end_date": "Data końcowa",
    "reset_selections": "Zresetuj wybór",
    "select_products_alert": "Wybierz produkty do wspólnego spakowania. Po spakowaniu zostaniesz powiadomiony i będziesz mógł wybrać opcje wysyłki na stronie 'Moje paczki'.",
    "estimated_weight": "Szacowana waga: {weight} kg",
    "rehearse_parcel": "Próba paczki",
    "request_packaging": "Zleć pakowanie",
    "orders_not_arrived_alert": "Masz {count} zamówień, które jeszcze nie dotarły do magazynu. Potwierdź, czy chcesz teraz spakować, czy poczekać na wszystkie przedmioty.",
    "table_empty_text": "Nic na tej stronie. Możesz sprawdzić inne strony.",
    "column_image": "Zdjęcie",
    "column_details": "Szczegóły",
    "order_label": "Zamówienie:",
    "total_label": "Suma:",
    "type_label": "Typ:",
    "status_label": "Status:",
    "time_label": "Czas:",
    "style_label": "Styl:",
    "quantity_prefix": "x",
    "no_remark": "Brak uwagi",
    "package_info_label": "Informacje o paczce",
    "weight_label": "Waga:",
    "length_label": "Długość:",
    "width_label": "Szerokość:",
    "height_label": "Wysokość:",
    "unit_kg": "kg",
    "unit_cm": "cm",
    "action_label": "Akcja",
    "view": "Zobacz",
    "photos": "Zdjęcia",
    "cancel": "Anuluj",
    "mobile_label_total": "Suma:",
    "mobile_label_type": "Typ:",
    "mobile_label_name": "Nazwa:",
    "view_product": "Zobacz produkt",
    "mobile_style_label": "Styl:",
    "no_items_selected": "Nie wybrano żadnych przedmiotów",
    "submit_packaging_request": "Wyślij prośbę o spakowanie",
    "dialog_request_packaging_title": "Prośba o spakowanie",
    "dialog_request_packaging_info": "Spakujemy wybrane przez Ciebie przedmioty razem. Po spakowaniu będziesz mógł zobaczyć rzeczywiste wymiary i wybrać opcje wysyłki w 'Moich paczkach'.",
    "packaging_instructions": "Instrukcje pakowania",
    "placeholder_packaging_instructions": "Specjalne instrukcje pakowania lub jakieś uwagi?",
    "selected_items": "Wybrane przedmioty",
    "packaging_note": "Uwaga: Po spakowaniu określimy dokładne wymiary i wagę Twojej paczki. Następnie będziesz mógł wybrać metodę wysyłki i podać swój adres w sekcji 'Moje paczki'.",
    "new_packaging_process": "Nowy proces pakowania",
    "step_request_packaging": "Zleć pakowanie:",
    "step_request_packaging_desc": "Wybierz produkty i prześlij prośbę o spakowanie.",
    "step_warehouse_packaging": "Pakowanie w magazynie:",
    "step_warehouse_packaging_desc": "Nasz personel spakuje wybrane przez Ciebie przedmioty.",
    "step_measurement": "Pomiar:",
    "step_measurement_desc": "Zmierzymy dokładne wymiary i wagę Twojej paczki.",
    "step_notification": "Powiadomienie:",
    "step_notification_desc": "Zostaniesz powiadomiony, gdy Twoja paczka będzie gotowa.",
    "step_shipping_setup": "Konfiguracja wysyłki:",
    "step_shipping_setup_desc": "Przejdź do 'Moich paczek', aby wybrać opcje wysyłki i wprowadzić swój adres.",
    "step_make_payment": "Dokonaj płatności:",
    "step_make_payment_desc": "Zapłać za wysyłkę na podstawie rzeczywistych wymiarów i wagi paczki.",
    "confirm_packaging_title": "Potwierdź prośbę o spakowanie",
    "confirm_packaging_text": "Zamierzasz zlecić spakowanie {count} przedmiotów. Kontynuować?",
    "item_qc_photos": "Zdjęcia QC przedmiotu",
    "empty_qc_desc": "Twój przedmiot jeszcze nie dotarł do naszego magazynu.",
    "return_items_title": "Zwróć przedmioty",
    "return_items_text": "Zwrot przedmiotów może wiązać się z dodatkowymi kosztami. Czy na pewno chcesz kontynuować?",
    "number_of_items_to_return": "Liczba przedmiotów do zwrotu:",
    "confirm": "Potwierdź"
  },
  "page_address_book": {
    "title": "Moja książka adresowa",
    "buttons": {
      "add_new": "Dodaj nowy",
      "save": "Zapisz adres"
    },
    "dialog": {
      "title": "Dodaj swój adres",
      "alert": "Dodaj swój adres, a będzie można go użyć następnym razem!",
      "form": {
        "contact_name": "Imię i nazwisko kontaktu",
        "address": "Adres",
        "city": "Miasto",
        "province": "Województwo/Prowincja",
        "country": "Kraj",
        "country_placeholder": "Wybierz kraj docelowy",
        "zip_code": "Kod pocztowy",
        "phone": "Telefon",
        "email": "E-mail",
        "email_placeholder": "Zalecane"
      }
    }
  },
  "page_wallet": {
    "header": {
      "title": "Podsumowanie portfela",
      "subtitle": "Zarządzaj swoim saldem i historią transakcji"
    },
    "balance_card": {
      "label": "Dostępne saldo",
      "currency": "USD",
      "top_up_button": "Doładuj saldo"
    },
    "history": {
      "title": "Historia transakcji",
      "count": "{count} transakcji",
      "empty": {
        "title": "Brak transakcji",
        "subtitle": "Twoja historia transakcji pojawi się tutaj"
      },
      "item": {
        "order_prefix": "Zamówienie:",
        "balance_after_prefix": "Saldo:",
        "note_prefix": "Uwaga:",
        "complete_payment_button": "Dokończ płatność",
        "mobile": {
          "order_id_label": "ID zamówienia:",
          "balance_after_label": "Saldo po:",
          "status_label": "Status:"
        }
      }
    },
    "top_up_dialog": {
      "title": "Doładuj",
      "form": {
        "amount_label": "Wprowadź kwotę (USD)",
        "quick_select_title": "Szybki wybór kwoty",
        "create_payment_button": "Utwórz płatność"
      }
    }
  },
  "page_message_center": {
    "title": "Centrum wiadomości",
    "filters": {
      "all": "Wszystkie",
      "unread": "Nieprzeczytane",
      "read": "Przeczytane",
      "search_placeholder": "Szukaj wiadomości..."
    },
    "actions": {
      "mark_all_read": "Oznacz wszystkie jako przeczytane",
      "delete_all": "Usuń wszystkie wiadomości",
      "refresh": "Odśwież wiadomości"
    },
    "delete_confirm": {
      "title": "Usunąć tę wiadomość?",
      "confirm_button": "Usuń",
      "cancel_button": "Anuluj"
    },
    "empty_states": {
      "no_search_results": "Nie znaleziono wiadomości pasujących do Twojego wyszukiwania.",
      "no_unread": "Nie masz nieprzeczytanych wiadomości.",
      "no_read": "Nie masz przeczytanych wiadomości.",
      "no_messages_yet": "Twoje centrum wiadomości jest puste."
    }
  },
  "page_user_profile": {
    "tabs": {
      "profile": "Profil",
      "account_safety": "Bezpieczeństwo konta"
    },
    "profile_section": {
      "email": "E-mail:",
      "gender": "Płeć:",
      "country": "Kraj:",
      "language": "Język:",
      "current_language": "Polski",
      "phone": "Telefon:",
      "birthday": "Data urodzenia:",
      "vip_prefix": "VIP",
      "max_vip_level": "VIP5",
      "privilege_title": "Moje przywileje",
      "privilege_table_header": "Przywilej poziomu"
    },
    "safety_section": {
      "modify_password_title": "Zmień hasło",
      "modify_password_desc": "Hasło o wyższym poziomie bezpieczeństwa sprawia, że Twoje konto jest bezpieczniejsze. Zaleca się regularną zmianę hasła, włączając w to cyfry i litery.",
      "modify_password_button": "Zmień hasło"
    },
    "update_info_dialog": {
      "title": "Zaktualizuj informacje o koncie",
      "account_name_label": "Nazwa konta",
      "phone_label": "Numer telefonu",
      "gender_label": "Płeć",
      "gender_placeholder": "Wybierz",
      "country_label": "Kraj",
      "country_placeholder": "Wybierz kraj",
      "birthday_label": "Data urodzenia",
      "birthday_placeholder": "Wybierz",
      "save_button": "Zapisz informacje"
    },
    "update_password_dialog": {
      "title": "Zaktualizuj hasło",
      "old_password_label": "Stare hasło",
      "new_password_label": "Nowe hasło",
      "confirm_password_label": "Potwierdź hasło",
      "save_button": "Zapisz"
    }
  },
  "page_shipping_calculator": {
    "hero": {
      "title": "Twój ostateczny chiński agent zakupowy"
    },
    "form_card": {
      "title": "Szacowanie kosztów wysyłki",
      "subtitle": "Wprowadź poniżej szczegóły swojej paczki, aby uzyskać dokładne koszty wysyłki",
      "country_label": "Kraj docelowy",
      "country_placeholder": "Wybierz kraj",
      "country_search_placeholder": "Szukaj kraju...",
      "no_countries_for_letter": "Brak krajów zaczynających się na {letter}.",
      "no_countries_for_search": "Nie znaleziono krajów dla \"{query}\".",
      "category_label": "Kategoria produktu",
      "category_placeholder": "Wybierz kategorię",
      "select_main_category_first": "Najpierw wybierz główną kategorię.",
      "weight_label": "Waga (kg)",
      "length_label": "Długość (cm)",
      "width_label": "Szerokość (cm)",
      "height_label": "Wysokość (cm)",
      "required_label": "Wymagane",
      "optional_label": "(Opcjonalnie)",
      "optional_placeholder": "Opcjonalnie",
      "calculating_button": "Obliczanie...",
      "submit_button": "Uzyskaj koszty wysyłki"
    },
    "summary": {
      "title": "Podsumowanie zapytania o wysyłkę",
      "sort_by": "Sortuj według:",
      "sort_price": "Cena",
      "sort_time": "Czas tranzytu",
      "destination": "Cel:",
      "weight": "Waga:",
      "dimensions": "Wymiary:",
      "volume": "Objętość:",
      "categories": "Kategorie:"
    },
    "results": {
      "loading_text": "Obliczanie dostępnych opcji wysyłki...",
      "no_options_title": "Brak dostępnych opcji wysyłki",
      "no_options_desc": "Nie znaleziono prawidłowych opcji wysyłki dla wprowadzonych szczegółów i celu. <br /> Sprawdź ograniczenia dotyczące wagi, wymiarów i kategorii produktów dla wybranego kraju.",
      "initial_state_text": "Wprowadź wymagane parametry (kraj, waga) i kliknij \"Uzyskaj koszty wysyłki\".",
      "all_unavailable_info": "Wszystkie kanały wysyłki dla tej kombinacji są niedostępne. Zobacz szczegóły poniżej.",
      "est_transit_time": "Szacowany czas tranzytu",
      "volume_weight": "Waga objętościowa",
      "billing_weight": "Waga do rozliczenia",
      "view_details_button": "Zobacz szczegóły",
      "load_more_button": "Załaduj więcej ({count} pozostało)",
      "unavailable_channels_title": "Niedostępne kanały wysyłki ({count})",
      "not_available_badge": "Niedostępne",
      "reason_prefix": "Powód:"
    },
    "details_modal": {
      "overview_title": "Podsumowanie wysyłki",
      "shipping_fee": "Opłata za wysyłkę",
      "description_title": "Opis usługi",
      "no_description": "Brak dostępnego opisu.",
      "restrictions_title": "Ograniczenia transportowe",
      "category_restrictions_title": "Ograniczenia kategorii produktów",
      "legend_can_send": "Można wysłać",
      "legend_cannot_send": "Nie można wysłać",
      "can_send_subheading": "Można wysłać:",
      "cannot_send_subheading": "Nie można wysłać:",
      "no_allowed_items": "Brak konkretnych dozwolonych przedmiotów na liście (przyjmuje się, że towary ogólne są dozwolone, chyba że są objęte ograniczeniami)",
      "no_prohibited_items": "Brak konkretnych zabronionych przedmiotów na liście (obowiązują standardowe zakazy przewoźnika)",
      "rules_title": "Zasady transportu",
      "weight_restriction_title": "Ograniczenie wagi",
      "dimension_restriction_title": "Ograniczenie wymiarów",
      "billing_rules_title": "Zasady rozliczeniowe",
      "tax_info_title": "Informacje podatkowe",
      "additional_fees_title": "Dodatkowe opłaty",
      "no_additional_fees": "Nie określono (mogą obowiązywać standardowe opłaty przewoźnika)",
      "min_label": "Min:",
      "max_label": "Maks:",
      "carrier_limit": "Limit przewoźnika",
      "close_button": "Zamknij"
    }
  },
  "page_shopping_guide": {
    "header": {
      "title": "Przewodnik po zakupach",
      "description": "Przewodnik po zakupach na Taobao, 1688, Weidian i Yupoo dla początkujących",
      "video_title": "Wideo z procesu zakupów"
    },
    "process": {
      "title": "Proces zakupów",
      "step1": {
        "title": "Krok 1: Wybierz produkt",
        "description": "Znajdź produkt, który chcesz na Taobao.com, 1688.com, Tmall.com lub Weidian."
      },
      "step2": {
        "title": "Krok 2: Wyszukaj produkt",
        "description": "Jeśli nie możesz znaleźć produktu, który chcesz, nie wahaj się poprosić o pomoc naszą całodobową obsługę klienta. Skopiuj i wklej link do produktu na stronie NiuNiuBox. Jeśli korzystasz z aplikacji Taobao, link do produktu znajdziesz również na stronie szczegółów produktu Taobao."
      },
      "step3": {
        "title": "Krok 3: Wybierz rozmiar/kolor",
        "description": "Potwierdź rozmiar i kolor potrzebnego produktu na NiuNiuBox, a następnie dodaj go do koszyka."
      },
      "step4": {
        "title": "Krok 4: Pierwsza płatność",
        "description": "Przejdź do koszyka i dokonaj pierwszej płatności za wybrane przedmioty."
      },
      "step5": {
        "title": "Krok 5: Prześlij swój adres",
        "description": "Gdy dokonasz pierwszej płatności, zespół NiuNiuBox zakupi dla Ciebie produkty. Po dotarciu wszystkich produktów do naszego magazynu, musisz podać swój adres, abyśmy mogli spakować Twoje przedmioty w jedno duże pudełko."
      },
      "step6": {
        "title": "Krok 6: Druga płatność",
        "description": "Po spakowaniu Twoich produktów otrzymasz e-mail z wagą paczki i kosztem wysyłki. Następnie musisz zapłacić za międzynarodową wysyłkę, a my wyślemy Twoją paczkę z naszego magazynu w Chinach na Twój adres."
      },
      "step7": {
        "title": "Krok 7: Oczekiwanie na paczkę",
        "description": "Po wysłaniu paczki otrzymasz numer śledzenia w ciągu 3 dni. Pozwoli Ci to sprawdzić lokalizację Twojej paczki."
      }
    }
  },
  "page_contact_us": {
    "title": "Skontaktuj się z nami",
    "support_email_label": "E-mail do obsługi klienta:"
  },
  "page_my_account": {
    "title": "Moje konto",
    "profile_card": {
      "member_type": "Zwykły członek",
      "member_since": "Członek od",
      "logout_confirm": "Czy na pewno chcesz się wylogować?",
      "top_up_button": "Doładuj",
      "orders_label": "Zamówienia",
      "coupons_label": "Kupony"
    },
    "balance_info": {
      "title": "O Twoim saldzie",
      "description": "Gdy poprosisz o anulowanie zamówienia, pozostałe środki zostaną automatycznie przelane na Twoje saldo.",
      "highlight1": "Kontynuuj zakupy ze swojego salda",
      "highlight2": "Skontaktuj się z obsługą klienta w celu uzyskania zwrotu pieniędzy na Twoje konto płatnicze"
    },
    "quick_actions": {
      "title": "Szybkie akcje",
      "shopping_orders": "Zamówienia zakupowe",
      "in_warehouse": "W magazynie",
      "my_rehearsal": "Moja próba",
      "my_parcels": "Moje paczki",
      "my_balance": "Moje saldo",
      "messages": "Wiadomości",
      "my_coupons": "Moje kupony",
      "cancel_order": "Anuluj zamówienie"
    },
    "recent_orders": {
      "title": "Ostatnie zamówienia",
      "view_all_button": "Zobacz wszystkie",
      "header_product": "Produkt",
      "header_amount": "Kwota",
      "header_date": "Data",
      "header_status": "Status",
      "header_actions": "Akcje",
      "quantity_prefix": "Ilość:",
      "details_button": "Szczegóły"
    },
    "invitation": {
      "title": "Zaproś znajomych",
      "description": "Udostępnij naszą stronę znajomym i zdobywaj nagrody:",
      "copy_button": "Kopiuj"
    }
  },
  "page_shopping_order": {
    "title": "Zamówienie zakupowe",
    "search": {
      "order_number_placeholder": "Numer zamówienia",
      "product_name_placeholder": "Nazwa produktu",
      "status_placeholder": "Proszę wybrać",
      "remark_placeholder": "Uwaga",
      "style_sku_placeholder": "Styl/SKU",
      "start_date_placeholder": "Data początkowa",
      "end_date_placeholder": "Data końcowa",
      "search_button": "Szukaj",
      "pay_button": "Zapłać za zamówienia"
    },
    "info_alert": "Ta strona pokazuje zamówienia zakupowe, takie jak z Taobao/1688/Weidian. Proszę wybrać zamówienia [Oczekujące na płatność] i zapłacić.",
    "table": {
      "empty_text": "Nie masz jeszcze żadnych zamówień zakupowych",
      "header": {
        "image": "Zdjęcie",
        "details": "Szczegóły",
        "product": "Produkt",
        "action": "Akcja"
      },
      "body": {
        "order_prefix": "Zamówienie:",
        "total_prefix": "Suma:",
        "type_prefix": "Typ:",
        "status_prefix": "Status:",
        "time_prefix": "Czas:",
        "style_prefix": "Styl:",
        "quantity_prefix": "Ilość:",
        "remark_prefix": "Uwaga:",
        "name_prefix": "Nazwa:"
      },
      "actions": {
        "pay_order": "Zapłać za zamówienie",
        "view_order": "Zobacz zamówienie",
        "item_photos": "Zdjęcia przedmiotu",
        "cancel_item": "Anuluj przedmiot",
        "view_product": "Zobacz produkt"
      }
    },
    "qc_dialog": {
      "title": "Zdjęcia QC przedmiotu",
      "empty_text": "Twój przedmiot jeszcze nie dotarł do naszego magazynu."
    },
    "return_dialog": {
      "title": "Zwróć przedmioty",
      "confirmation_text": "Zwrot przedmiotów może wiązać się z dodatkowymi kosztami. Czy na pewno chcesz kontynuować?",
      "quantity_label": "Liczba przedmiotów do zwrotu:",
      "cancel_button": "Anuluj",
      "confirm_button": "Potwierdź"
    },
    "cancel_dialog": {
      "title": "Anuluj zamówienie",
      "confirmation_text": "Jeśli chcesz anulować to zamówienie, będziesz musiał ponieść koszty wysyłki. Opłata zostanie potrącona z już dokonanej płatności. Czy chcesz kontynuować?",
      "cancel_button": "Anuluj",
      "confirm_button": "Potwierdź"
    }
  },
  "page_shipping_config": {
    "title": "Konfiguracja wysyłki",
    "summary": {
      "destination": "Cel:",
      "actual_weight": "Rzeczywista waga paczki:",
      "est_dimensions": "Szacowane wymiary:",
      "weight_note": "*Szacowana waga paczki opiera się na wadze produktu, a rzeczywista waga zostanie określona po zważeniu.",
      "product_types": "Typy produktów",
      "selected_method": "Wybrana metoda wysyłki:",
      "selected_method_none": "Brak",
      "est_fee": "Szacowana opłata:"
    },
    "status": {
      "loading": "Obliczanie dostępnych opcji wysyłki...",
      "no_options": "Brak dostępnych opcji wysyłki dla obecnej wagi, wymiarów, typów produktów i kraju. <br />Proszę sprawdzić ograniczenia."
    },
    "options": {
      "select_sr_label": "Wybierz {channelName}",
      "shipping_fee": "Opłata za wysyłkę",
      "volume_weight": "Waga objętościowa",
      "volume_weight_formula": "Waga objętościowa (kg) = D*S*W (cm) / {denominator}",
      "billing_weight": "Waga do rozliczenia",
      "billing_weight_details": "Na podstawie większej wartości z wagi rzeczywistej ({weight} kg) i wagi objętościowej. Mogą obowiązywać zaokrąglenia i minima zgodnie z zasadami kanału.",
      "transit_time": "Czas tranzytu",
      "hide_details_button": "Ukryj szczegóły",
      "show_details_button": "Pokaż szczegóły"
    },
    "details": {
      "category_restrictions_title": "Ograniczenia kategorii produktów",
      "legend_can_send": "Można wysłać",
      "legend_cannot_send": "Nie można wysłać",
      "can_send_subheading": "Można wysłać:",
      "no_allowed_items": "Brak konkretnych dozwolonych przedmiotów na liście (przyjmuje się, że towary ogólne są dozwolone, chyba że są objęte ograniczeniami)",
      "cannot_send_subheading": "Nie można wysłać:",
      "no_prohibited_items": "Brak konkretnych zabronionych przedmiotów na liście (obowiązują standardowe zakazy przewoźnika)",
      "rules_title": "Zasady transportu",
      "weight_restriction_title": "Ograniczenie wagi",
      "min_label": "Min:",
      "max_label": "Maks:",
      "carrier_limit": "Limit przewoźnika",
      "dimension_restriction_title": "Ograniczenie wymiarów",
      "billing_rules_title": "Zasady rozliczeniowe",
      "tax_info_title": "Informacje podatkowe",
      "additional_fees_title": "Dodatkowe opłaty",
      "no_additional_fees": "Nie określono (mogą obowiązywać standardowe opłaty przewoźnika)"
    },
    "confirm_button": "Potwierdź"
  },
  "page_parcel_details": {
    "loading": "Ładowanie szczegółów paczki...",
    "overview": {
      "title": "Podsumowanie paczki",
      "parcel_id": "ID paczki",
      "payment_time": "Czas płatności",
      "status": "Status",
      "shipping_cost": "Koszt wysyłki",
      "billing_weight": "Waga do rozliczenia",
      "parcel_remark": "Uwaga do paczki",
      "your_note": "Twoja notatka"
    },
    "tracking": {
      "title": "Informacje o śledzeniu",
      "empty_text": "Brak informacji o śledzeniu. Otrzymasz numer śledzenia po wysłaniu (~3 dni)."
    },
    "items": {
      "title": "Pozycje produktów",
      "empty_text": "Nie znaleziono pozycji",
      "header_order_image": "Zamówienie / Zdjęcie",
      "header_product_details": "Szczegóły produktu",
      "header_qc_photos": "Zdjęcia QC",
      "order_prefix": "Zamówienie:",
      "sku_prefix": "SKU:",
      "quantity_prefix": "Ilość:",
      "note_prefix": "Notatka:"
    }
  },
  "page_affiliate": {
    "header": {
      "title": "30% wzrostu bonusu",
      "description": "Na podstawie bonusu za wysyłkę nowych partnerów"
    },
    "commission": {
      "title": "Moja prowizja promocyjna",
      "invited_users": "Zaproszeni użytkownicy:",
      "new_affiliates": "Nowi partnerzy:",
      "active_users": "Aktywni użytkownicy:"
    },
    "balance": {
      "title": "Moje saldo partnerskie",
      "amount_withdrawn": "Wypłacona kwota:",
      "withdrawn_button": "Wypłać",
      "withdrawable_title": "Do wypłaty",
      "board_earnings_title": "Zarobki z tworzenia tablic",
      "claim_button": "Odbierz"
    },
    "steps": {
      "step1": "Udostępnij kody zaproszeń znajomym",
      "step2": "Znajomy złożył zamówienie i otrzymał paczkę",
      "step3": "Otrzymaj prowizję"
    },
    "promotion_method": {
      "title": "Metoda promocji",
      "mobile_description": "Opis zasady Opis zasady Opis zasady",
      "desktop_description": "Prowizja, którą otrzymujesz co miesiąc, zostanie przelana bezpośrednio na Twoje konto osobiste.",
      "invite_link_label": "Link zaproszeniowy:",
      "copy_link_button": "Kopiuj link",
      "copy_code_button": "Kopiuj kod zaproszenia",
      "download_qr_button": "Pobierz kod QR"
    }
  },
  "page_product_details": {
    "promo_banner": "Kupuj opłacalne produkty z chińskich stron e-commerce i oszczędzaj więcej pieniędzy. Wysyłka na cały świat z Chin.",
    "stats": {
      "sales": "Sprzedaż:",
      "inventory": "Stan magazynowy:"
    },
    "info": {
      "original_link": "Oryginalny link",
      "processing_time": "Po dokonaniu płatności kupimy dla Ciebie w ciągu 12 godzin.",
      "domestic_shipping": "Wysyłka krajowa",
      "free_shipping": "Darmowa wysyłka",
      "shipping_note": "Lokalny koszt wysyłki od sprzedawcy do naszego magazynu w Chinach."
    },
    "options": {
      "quantity": "Ilość",
      "items_available": "Dostępnych {count} sztuk",
      "order_remark": "Uwaga do zamówienia:",
      "order_remark_subtitle": "Dodaj wszelkie instrukcje lub specjalne prośby",
      "remark_placeholder": "Proszę zostawić wiadomość dla sprzedawcy, np. kolor, rozmiar itp."
    },
    "actions": {
      "shipping_cost_estimate": "Szacowanie kosztów wysyłki",
      "disclaimer_title": "Zastrzeżenie",
      "disclaimer_text": "Wszystkie produkty dostępne w ramach usługi agenta zakupowego wyświetlane na Niuniubox pochodzą z platform zakupowych stron trzecich i nie są sprzedawane bezpośrednio przez Niuniubox. W związku z tym Niuniubox nie ponosi odpowiedzialności prawnej za problemy wynikające z naruszenia praw własności intelektualnej i praw autorskich do towarów.",
      "agreement_checkbox": "Przeczytałem i zgadzam się",
      "buy_now": "Kup teraz",
      "add_to_cart": "Dodaj do koszyka",
      "share": "Udostępnij"
    },
    "share_dialog": {
      "title": "Udostępnij ten produkt",
      "platform_facebook": "Facebook",
      "platform_whatsapp": "WhatsApp",
      "platform_wechat": "WeChat",
      "platform_discord": "Discord",
      "platform_email": "E-mail",
      "copy_button": "Kopiuj"
    },
    "sidebar": {
      "original_site": "Oryginalna strona:",
      "why_title": "Dlaczego Taobao, 1688, Weidian, Yupoo, Tmall?",
      "why_description": "Produkty na tych platformach są bardzo tanie. Jeśli chcesz wydać jak najmniej pieniędzy na zakup wysokiej jakości produktów, zakupy na tych platformach są najbardziej opłacalne. Oferujemy globalne usługi logistyczne drogą powietrzną i morską.",
      "details_title": "Szczegóły produktu",
      "empty_details": "Puste szczegóły produktu."
    },
    "loading": {
      "try_again": "Spróbuj ponownie",
      "note_title": "Uwaga:",
      "error_note_1": "1. Możesz skontaktować się z nami, jeśli nie widzisz informacji o produkcie.",
      "error_note_2": "2. Produkt jest wyprzedany lub adres URL produktu jest nieprawidłowy. Sprawdź link do swojego produktu.",
      "error_note_3": "3. Obsługiwane platformy: Taobao.com, 1688.com, Tmall.com, Weidian.com (obsługuje tylko adresy URL produktów)"
    }
  },
  "shopping_steps": {
    "title": "Jak to działa",
    "steps_data": [
      {
        "title": "Znajdź produkty",
        "des": "Przeglądaj miliony produktów z chińskich rynków, takich jak Taobao, 1688, Weidian, Tmall po cenach hurtowych"
      },
      {
        "title": "Dodaj do koszyka",
        "des": "Wybierz swoje przedmioty, wybierz specyfikacje i dodaj je do koszyka, aby łatwo zarządzać zamówieniami"
      },
      {
        "title": "Przejdź do kasy",
        "des": "Bezpiecznie zapłać za swoje przedmioty, a my kupimy je dla Ciebie od różnych sprzedawców"
      },
      {
        "title": "Odbierz dostawę",
        "des": "Wysyłamy Twoją skonsolidowaną paczkę z Chin prosto pod Twoje drzwi z pełnymi informacjami o śledzeniu"
      }
    ]
  }
}